import React from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";

export default function SuccessStep({
  passwordWasUpdated,
  alreadyCompleted,
  onClose,
}) {
  return (
    <div className="onboarding-success">
      <div role="status" aria-live="polite">
        <div className="onboarding-success-mark" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="m5 12.5 4.3 4.2L19.5 6.8"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2>{alreadyCompleted ? "Tu ficha ya estaba completada" : "Tu ficha de salud quedó completada"}</h2>
        <p>
          {alreadyCompleted
            ? "El estado de tu ficha ya está guardado en tu cuenta."
            : "Tus respuestas se guardaron en tu cuenta y el estado ya fue confirmado."}
        </p>
        {passwordWasUpdated && <p>Tu contraseña se actualizó.</p>}
      </div>

      <section className="onboarding-app-resources" aria-labelledby="onboarding-app-title">
        <h3 id="onboarding-app-title">Continúa en la app de IBICARE</h3>
        <p>Conoce cómo empezar y descarga la app en tu dispositivo.</p>
        <div className="onboarding-video">
          <iframe
            src="https://www.youtube.com/embed/FhBuXgvJMxc?si=5DgvSCrqPtO4Lx0l"
            title="Cómo comenzar a usar la app de IBICARE"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
        <div className="onboarding-store-links">
          <a
            className="onboarding-store-link"
            href="https://apps.apple.com/mx/app/ibicare/id6449553915"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaApple aria-hidden="true" />
            <span>Descargar en App Store</span>
          </a>
          <a
            className="onboarding-store-link"
            href="https://play.google.com/store/apps/details?id=mx.ibicare.IbicareApp&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGooglePlay aria-hidden="true" />
            <span>Disponible en Google Play</span>
          </a>
        </div>
      </section>

      <button
        className="onboarding-button onboarding-button--primary"
        type="button"
        onClick={onClose}
      >
        Cerrar recorrido
      </button>
    </div>
  );
}
